import { getGoToFairePosCTA } from "./shared";
export var LinkingPosIA = function LinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return LINKING_YOUR_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize)];
    }
  };
};
var LINKING_YOUR_POS = function LINKING_YOUR_POS(strictLocalize) {
  return strictLocalize({
    id: "D6ODY0",
    defaultMessage: "Linking your POS"
  });
};
var TO_SET_UP_YOUR_POS_INTEGRATION = function TO_SET_UP_YOUR_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "EoCgJq",
    defaultMessage: "You can set up your POS integration by clicking the user-icon button in the upper-right corner of the retailer portal and selecting the “Connect My POS” option. You can read more about the process in the help center article. Please contact us if you need any further help."
  });
};